import { render, staticRenderFns } from "./DemoMode.vue?vue&type=template&id=55ab4fb1"
import script from "./DemoMode.vue?vue&type=script&lang=js"
export * from "./DemoMode.vue?vue&type=script&lang=js"
import style0 from "./DemoMode.vue?vue&type=style&index=0&id=55ab4fb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports